<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto" tile>
        <InputBuscar :filter="filter" @input="filter = $event">
          <BotonAgregar @mostrarModalAgregar="irAgregar" :textoBoton="$t('vUsuarios.agregarUsuario')"
            :iconBoton="iconBoton" />
        </InputBuscar>
        <b-row>
          <div class="col-md-12" style="margin-top: -8px">
            <!-- Tabla agrupada por área -->
            <div v-if="mostrarAgrupadoPorArea">
              <div v-for="(usuarios, area) in usuariosAgrupadosPorArea" :key="area" class="mb-4">
                <div class="area-header mb-2">
                  <h5 class="mb-1">
                    <feather type="users" class="feather-sm mr-2"></feather>
                    {{ area }}
                  </h5>
                </div>
                <BaseTable tableClass="mb3 tblusuarios" :items="usuarios" :fields="translatedHeaders" :currentPage="1"
                  :perPage="perPage" :filter="filter" :total-rows="usuarios.length">
                  <template #cell(Acciones)="data">
                    <div class="d-flex flex-row align-items-center">
                      <div class="p-1" v-if="data.item.id != id">
                        <b-form-checkbox switch size="sm" v-model="data.item.habilitado"
                          @click.native="showAlert(data.item)" v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)
                            ">
                        </b-form-checkbox>
                      </div>
                      <div class="p-1" v-if="data.item.id == id">
                        <b-form-checkbox switch size="sm" v-model="data.item.habilitado" :disabled="true"
                          v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)
                            ">
                        </b-form-checkbox>
                      </div>
                      <div class="p-1">
                        <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="editar(data.item)"
                          v-b-tooltip.hover :title="$t('Gral.editar')">
                          <feather type="edit" class="feather-sm mr-2"></feather>
                        </b-button>
                      </div>
                      <div class="p-1">
                        <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                          @click="resetear(data.item)" v-b-tooltip.hover :title="$t('vUsuarios.restablecerPass')">
                          <feather type="key" class="feather-sm mr-2"></feather>
                        </b-button>
                      </div>
                      <div class="p-1" v-if="master && data.item.id != id && data.item.role.id != idMaster">
                        <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                          @click="verUsuario(data.item)" v-b-tooltip.hover :title="$t('ver') + ' ' + data.item.rol">
                          <feather type="eye" class="feather-sm mr-2"></feather>
                        </b-button>
                      </div>
                      <!--Cerrar sesiones-->
                      <div class="p-1">
                        <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                          @click="cerrarSesionUsuario(data.item)" v-b-tooltip.hover title="Cerrar Sesión">
                          <feather type="power" class="feather-sm mr-2"></feather>
                        </b-button>
                      </div>
                    </div>
                  </template>
                </BaseTable>
              </div>
            </div>

            <!-- Tabla normal sin agrupación -->
            <BaseTable v-else tableClass="mb3 tblusuarios" :items="usuariosTodos" :fields="translatedHeaders"
              :currentPage="currentPage" :perPage="perPage" :filter="filter" @filtered="onFiltered"
              :total-rows="totalRows">
              <template #cell(areasAsignadas)="data">
                <div>
                  <span v-for="(a, i) in data.item.areasAsignadas" :key="a.id || i" class="badge badge-primary mr-1">
                    {{ a.nombre }}
                  </span>
                </div>
              </template>

              <template #cell(Acciones)="data">
                <div class="d-flex flex-row align-items-center">
                  <div class="p-1" v-if="data.item.id != id">
                    <b-form-checkbox switch size="sm" v-model="data.item.habilitado"
                      :set="(titulo = hoverHabilitado(data.item))" @click.native="showAlert(data.item)"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1" v-if="data.item.id == id">
                    <b-form-checkbox switch size="sm" v-model="data.item.habilitado" :disabled="true"
                      :set="(titulo = hoverHabilitado(data.item))"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="editar(data.item)"
                      v-b-tooltip.hover :title="$t('Gral.editar')">
                      <feather type="edit" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="resetear(data.item)"
                      v-b-tooltip.hover :title="$t('vUsuarios.restablecerPass')">
                      <feather type="key" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                  <div class="p-1" v-if="
                    master &&
                    data.item.id != id &&
                    data.item.role.id != idMaster
                  ">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="verUsuario(data.item)"
                      v-b-tooltip.hover :title="$t('ver') + ' ' + data.item.rol">
                      <feather type="eye" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                  <!--Cerrar sesiones-->
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                      @click="cerrarSesionUsuario(data.item)" v-b-tooltip.hover title="Cerrar Sesión">
                      <feather type="power" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                </div>
              </template>
            </BaseTable>
          </div>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import UsersDataService from "../../../services/UsersDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";

import InputBuscar from "../../components/InputBuscar.vue";
import BotonAgregar from "../../components/BotonAgregar.vue";
import BaseTable from "../../components/BaseTable.vue";

import { verificarAcceso } from "../../../utils/Session";
import { generalSweetAlert, destruirAlerta } from "../../../utils/Utils";

import AreaDataService from "../../../services/AreaDataService";

export default {
  name: "usuario_list",
  components: {
    InputBuscar,
    BotonAgregar,
    BaseTable,
  },
  data() {
    return {
      usuariosTodos: [],
      matriculaActual: sessionStorage.getItem("username"),
      administrador: process.env.VUE_APP_ID_ADMINISTRADOR,
      idMaster: process.env.VUE_APP_ID_MASTER,
      id: sessionStorage.getItem("id_user"),
      title: "",
      dialog: false,
      sinDispo: [],
      confirmarDesh: false,
      filter: null,
      master: false,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      mostrarAgrupadoPorArea: false,
      headers: [
        {
          key: "matricula",
          label: "usuario",
          sortable: true,
        },
        {
          key: "rol",
          label: "rol",
          sortable: true,
        },
        {
          key: "Acciones",
          label: "acciones",
          class: "largo-columna-acciones",
        },
      ],
      totalRows: 10,
      currentPage: 1,
      perPage: 10,
      filterOn: [],
      key: "",
      iconBoton: "user-plus",
      areas: [],
    };
  },

  beforeCreate() {
    verificarAcceso();
  },

  async mounted() {
    this.key = sessionStorage.getItem("key");

    const sToken = sessionStorage.getItem("token")
    const validToken = await AccionesDataService.validarTokenExistenteAllowList(sToken, this.key);
    if (!validToken) {
      this.cerrarSesion();
      return
    }

    this.$nextTick(() => {
      this.obtenerAreas();
      this.obtenerUsuarios();
    });
  },
  computed: {
    ...mapState(["locale"]),
    translatedHeaders() {
      return this.headers.map((header) => {
        if (typeof header === "object" && header.label) {
          return {
            ...header,
            label: this.$t(`tableHeaders.${header.label}`),
          };
        } else {
          return header;
        }
      });
    },

    usuariosAgrupadosPorArea() {
      const grupos = {};

      this.usuariosTodos.forEach((usuario) => {
        const nombreArea = usuario.area?.nombre || "Sin área";

        if (!grupos[nombreArea]) {
          grupos[nombreArea] = [];
        }

        grupos[nombreArea].push(usuario);
      });

      // Ordenar cada grupo por matrícula
      Object.keys(grupos).forEach((area) => {
        grupos[area].sort((a, b) => a.matricula.localeCompare(b.matricula));
      });

      return grupos;
    },
  },
  methods: {

    cerrarSesion() {
      sessionStorage.clear();
      localStorage.clear();
      localStorage.removeItem("tokenSesion");
      localStorage.removeItem("servidor");
      localStorage.removeItem("aciqui_instance");

      destruirAlerta();
      this.$router.push({
        path: "/"
      });
    },
    obtenerAreas() {
      AreaDataService.getHabilitados().then(async (response) => {
        this.areas = await Crypto.desencriptar(response.data, this.key);

        if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
          this.master = true;
        }
      });
    },



    obtenerUsuarios() {
      UsersDataService.getAll().then(async (response) => {
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.usuariosTodos = decoded.map(this.getDisplayUsuario);

        const usuarioFiltro = JSON.parse(sessionStorage.getItem("usuarioFiltro") || "null");
        const usuarioActual = JSON.parse(sessionStorage.getItem("usuarioLogueado") || "null");
        const esMaster = sessionStorage.idRol === process.env.VUE_APP_ID_MASTER && !usuarioFiltro;

        // 1. CONFIGURACIÓN POR DEFECTO (Admin y otros roles)
        this.mostrarAgrupadoPorArea = true;
        this.master = false;
        this.headers = [
          { key: "matricula", label: "usuario", sortable: true },
          { key: "rol", label: "rol", sortable: true },
          { key: "Acciones", label: "acciones", class: "largo-columna-acciones" }
        ];

        // 2. LÓGICA DE FILTRADO PARA ADMIN / GRUPOS
        const esAdmin = usuarioActual?.rol?.id === process.env.VUE_APP_ID_ADMINISTRADOR;

        if (usuarioFiltro || esAdmin) {
          const user = usuarioFiltro || usuarioActual;
          const usuariosGrupo = [];

          this.usuariosTodos.forEach((value) => {
            if (value.area != null) {
              const area = value.area;
              const areaIdValue = String(area.id || area._id || "");
              const userAreaId = String(user.area?.id || user.area?._id || "");
              const adminIds = Array.isArray(area.adminIds) ? area.adminIds.map(String) : [];

              const coincidePorArea = (areaIdValue && userAreaId && areaIdValue === userAreaId) ||
                adminIds.includes(String(user.id));

              if (coincidePorArea && value.role && !(usuarioFiltro && String(value.id) === String(usuarioFiltro.id))) {
                usuariosGrupo.push(value);
              } else if (!usuarioFiltro && String(value.id) === String(user.id)) {
                usuariosGrupo.push(value);
              }
            }
          });
          this.usuariosTodos = usuariosGrupo;

        } else if (esMaster) {
          // 3. CONFIGURACIÓN ESPECIAL PARA MASTER
          this.usuariosTodos.forEach((value, index) => {
            if (!value.area) this.usuariosTodos[index].area = { nombre: "No aplica" };

            // Lógica de areasAsignadas...
            if (value.areaIds?.length > 0) {
              value.areasAsignadas = value.areaIds.map(id => {
                const found = this.areas?.find(a => (a.id || a._id) === id);
                return found ? { id: found.id || found._id, nombre: found.nombre } : { id, nombre: id };
              });
            } else {
              value.areasAsignadas = [{ id: value.area?.id || null, nombre: value.area?.nombre || "No aplica" }];
            }
          });

          this.headers.splice(2, 0, { key: "areasAsignadas", label: "areasAsignadas", sortable: false });
          this.master = true;
          this.mostrarAgrupadoPorArea = false;
        }

        // 4. LIMPIEZA FINAL
        const eliminarUsuario = usuarioFiltro || usuarioActual;
        if (eliminarUsuario?.id) {
          const idStr = String(eliminarUsuario.id);
          this.usuariosTodos = this.usuariosTodos.filter(u => String(u.id) !== idStr);
        }

        this.totalRows = this.usuariosTodos.length;
      });
    },

    getDisplayUsuario(usuario) {
      return {
        id: usuario.id,
        matricula: usuario.matricula,
        nombre: usuario.nombre,
        apellido: usuario.apellido,
        contrasena: usuario.contrasena,
        rol: usuario.rol == null ? "NULL" : usuario.rol.role,
        role: usuario.rol,
        habilitado: usuario.habilitado,
        area: usuario.area,
        administrador: usuario.administrador,
        areaIds: usuario.areaIds,
      };
    },

    editar(datos) {
      sessionStorage.setItem("matricula", datos.matricula);
      sessionStorage.setItem("userPwd", datos.contrasena);
      this.$router.push({
        name: "Editar usuario",
        params: {
          nombre: datos.nombre,
          apellido: datos.apellido,
          id: datos.id,
          contrasena: datos.contrasena,
          matricula: datos.matricula,
          extra: "1",
          role: datos.role,
          habilitado: datos.habilitado,
          area: datos.area,
          administrador: datos.administrador,
          areaIds: datos.areaIds,
        },
      });
    },

    showAlert(datos) {
      let habilitarTranslate = "";
      let habilitarAccion = "";
      if (datos.habilitado === true) {
        habilitarTranslate = this.$t("Gral.des");
        habilitarAccion = "desh";
      } else {
        habilitarTranslate = this.$t("Gral.h");
        habilitarAccion = "h";
      }
      this.$swal({
        text: this.$t("vUsuarios.habUser", { 0: habilitarTranslate }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        iconColor: "red",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.setItem("matricula", datos.matricula);
          UsersDataService.habilitar(this.key).then((response) => {
            if (response.status == 200) {
              this.accion =
                "Ha " +
                habilitarAccion +
                "abilitado al usuario " +
                datos.matricula;
              this.registrarAccion();
              this.obtenerUsuarios();

              generalSweetAlert(
                this.$t("vUsuarios.msgHabUser", { 0: habilitarTranslate }),
                "success"
              );
            }
          });
        } else {
          datos.habilitado = !datos.habilitado;
        }
      });
    },

    resetear(datos) {
      this.$swal({
        text: this.$t("vUsuarios.msgContrasena"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.accion =
            "Asignó una contraseña temporal al usuario " + datos.matricula;
          this.registrarAccion();
          UsersDataService.resetearContrasena(datos.id, this.key)
            .then(async (response) => {
              const decoded = await Crypto.desencriptar(response.data, this.key);
              this.$swal({
                html:
                  this.$t("vUsuarios.msgAsignarContra") +
                  ":<br>" +
                  decoded.contrasenaTemporal,
                icon: "success",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "gray",
                confirmButtonText: this.$t("Gral.aceptar"),
              });
            })
            .catch((e) => {
              const s = "401";
              if (e.toString().includes(s)) {
                this.$router.push({
                  path: "/",
                });

                generalSweetAlert(this.$t("Gral.msgSesion"), "warning");
              } else {
                generalSweetAlert(
                  this.$t("vUsuarios.msgErrorContrasena"),
                  "error"
                );
              }
            });
        }
      });
    },

    verUsuario(datos) {
      this.$swal({
        text: this.$t("vUsuarios.msgVerUsuario", {
          0: datos.rol,
          1: datos.matricula,
        }),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.setItem("nombreUsuario", datos.matricula);
          sessionStorage.setItem("id", datos.id);
          this.accion =
            "Visualizó el espacio de trabajo del " +
            datos.rol +
            " " +
            datos.matricula;
          this.registrarAccion();
          UsersDataService.filtroUsuario(datos.id, this.key).then(async (response) => {
            const decodded = await Crypto.desencriptar(response.data, this.key);
            sessionStorage.setItem("usuarioFiltro", JSON.stringify(decodded));

            sessionStorage.setItem("botonMasterVisible", "true");

            this.$router.push({
              path: "/monitoreo",
            });
            location.reload();
          }
          );
        }
      });
    },

    irAgregar() {
      this.$router.push({
        path: "/AddUsuario",
      });
    },

    hoverHabilitado(hab) {
      if (hab) return this.$t("Gral.deshabilitar");
      else return this.$t("Gral.habilitar");
    },

    registrarAccion() {
      let data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems;
      this.currentPage = 1;
    },

    /**
     * Metodo que abre un dialog y al confirmar cierra todas las sesiones abiertas del usuario.
     * @param usuario Datos del usuario al que le cerraremos la sesion
     */
    cerrarSesionUsuario(usuario) {
      this.$swal({
        text: `¿Está seguro de que desea cerrar la sesión del usuario: ${usuario.matricula} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        iconColor: "red",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          //Realizar cierre de sesiones
          UsersDataService.cerrarSesionUsuarios(usuario, this.key).then(
            (response) => {
              console.log("response:: ", response);
              if (response.data) {
                generalSweetAlert("Sesiones cerradas correctamente.", "success");
              } else {
                generalSweetAlert("Ocurrio un error al intentar cerrar las sesiones.", "warning");
              }
            }
          );
        } else if (result.isDismissed) {
          console.log("Cierre de sesiones cancelado");
        }
      });
    },


  },// ENd Methods
};
</script>

<style>
.card-body {
  margin: 0.7rem;
}

.area-badge {
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 20px;
  align-items: center;
  transition: all 0.2s ease;
  cursor: default;
}

.area-badge:hover {
  transform: scale(1.05);
  background-color: #0d6efd !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.area-header {
  background: linear-gradient(135deg, #2a6ba3 0%, #104b80 100%);
  color: #fff !important;
  padding: 10px 15px;
  box-shadow: 0 1px 4px rgba(23, 107, 182, 0.25);
}

.area-header h5,
.area-header .feather {
  color: #ffffff !important;
  fill: #ffffff !important;
}

.area-header .badge-primary {
  background-color: #ffffff;
  color: #176bb6;
}

.styleTitleB {
  font-size: 25px;
  font-weight: bold;
  color: rgb(12, 33, 92);
  margin-top: 0px;
  margin-bottom: 20px;
}

.verde {
  color: green;
}

.gris {
  fill: #54667a;
  color: #fff;
}

.largo-columna-1 {
  width: 800px;
}

.largo-columna-2 {
  width: 500px;
}

.largo-columna-acciones {
  width: 200px;
}

@media only screen and (max-width: 1600px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 991px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 767px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-height: 450px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media (max-width: 992px) {

  .boton-limpiar,
  .boton-agregar {
    margin-top: -16px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {

  .tblusuarios table,
  .tblusuarios thead,
  .tblusuarios tbody,
  .tblusuarios th,
  .tblusuarios td,
  .tblusuarios tr {
    display: block;
  }

  .tblusuarios thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tblusuarios tr {
    border: 1px solid #ccc;
  }

  .tblusuarios td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .tblusuarios td:after {
    position: relative;
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }

  .tblusuarios td:first-child:before {
    content: "Usuario: ";
  }

  .tblusuarios td:nth-of-type(2):before {
    content: "Rol: ";
  }

  .tblusuarios td:nth-of-type(3):before {
    content: "Grupo: ";
  }

  .tblusuarios td:last-child:before {
    content: "Acciones: ";
  }
}

.vertical-center {
  min-height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
}
</style>
